import React, { ChangeEvent, Component } from "react";
import { observer } from "mobx-react";

import { ITeleopJoystickAxisConfiguration } from "@formant/core/model/ITeleopJoystickAxisConfiguration";
import { ITeleopJoystickConfiguration } from "@formant/core/model/ITeleopJoystickConfiguration";
import { IValidation } from "@formant/core/model/IValidation";
import { teleopJoystickPositions } from "@formant/core/model/teleopJoystickPositions";
import { InputElement } from "@formant/ui/component/common/Field";

import { SelectField } from "../common/SelectField";
import { Switch } from "../common/Switch";
import { ValidationMessages } from "../common/ValidationMessages";
import { JoystickAxisConfiguration } from "./JoystickAxisConfiguration";
import * as styles from "./JoystickConfigurationRow.scss";

export interface IJoystickConfigurationRowProps {
    joystick: ITeleopJoystickConfiguration;
    validation?: IValidation;
    onEdit: (joystick: ITeleopJoystickConfiguration, i: number) => void;
    onRemove: (index: number) => void;
    index: number;
}

@observer
export class JoystickConfigurationRow extends Component<IJoystickConfigurationRowProps> {
    public render() {
        const {
            joystick: { position, x, y },
            validation,
            index,
        } = this.props;

        const xAxis = x && (
            <JoystickAxisConfiguration
                axisConfig={x}
                axis="x"
                validation={validation}
                joystickIndex={index}
                onEdit={this.onEditAxis}
            />
        );

        const yAxis = y && (
            <JoystickAxisConfiguration
                axisConfig={y}
                axis="y"
                joystickIndex={index}
                validation={validation}
                onEdit={this.onEditAxis}
            />
        );

        return (
            <div className={styles["joystick-configuration-row"]}>
                <div className={styles.header}>
                    <span className={styles.text}>Position</span>
                    <SelectField
                        className={styles.position}
                        small={true}
                        value={position}
                        onChange={this.onChangePosition}
                    >
                        {teleopJoystickPositions.map(_ => (
                            <option key={_} value={_}>
                                {_}
                            </option>
                        ))}
                    </SelectField>
                    <Switch onChange={this.onRemove} state={true} />
                </div>
                {xAxis}
                {yAxis}

                <ValidationMessages
                    validation={validation}
                    keys={Object.keys(validation || {}).filter(
                        _ =>
                            _ === "document.teleop.joysticks" ||
                            _.includes(`document.teleop.joysticks.${index}`),
                    )}
                />
            </div>
        );
    }

    private onRemove = () => {
        const { index, onRemove } = this.props;
        onRemove(index);
    };

    private onEditAxis = (
        axisConfiguration: ITeleopJoystickAxisConfiguration,
        axisLabel: string,
    ) => {
        const { joystick, index, onEdit } = this.props;

        if (axisLabel === "x") {
            joystick.x = axisConfiguration;
        }

        if (axisLabel === "y") {
            joystick.y = axisConfiguration;
        }

        onEdit(joystick, index);
    };

    private onChangePosition = (event: ChangeEvent<InputElement>) => {
        const { joystick, index, onEdit } = this.props;

        const position = teleopJoystickPositions.find(
            _ => _ === event.target.value,
        );

        joystick.position = position;

        onEdit(joystick, index);
    };
}
